import { mountApp } from './mountApp'

mountApp()
